(() => {
  // Find the region form
  [...document.querySelectorAll('.js-region-select')].forEach(form => {
    // Find the select element
    const select = form.querySelector('select');
    // Find the confirm button
    // const confirm = form.querySelector('button');
    // Store some timeouts
    const timeouts = {};
    // Store the initial region
    const initialRegion = select?.value;
    // The XHR request
    // const xhr = new XMLHttpRequest();
    // XHR URL
    // const url = '/api/close?region=';

    const onChange = () => {
      const selected = select.SimpleSelector.selection[0] || false;
      const value = selected ? selected.default.value : false;
      if (!value || value === initialRegion) return;
      clearTimeout(timeouts.submit);
      dataLayer.push({
        event: "country_selected",
        country_value: value
      });
      timeouts.submit = setTimeout(() => form.submit(), 100);
    };
    if (!select) return;
    select.addEventListener('SimpleSelector:close', onChange);

    // // When the confirm button is clicked, remove the form
    // confirm.addEventListener('click', (e) => {
    //   e.preventDefault();

    //   form.parentNode.removeChild(form);
    //   window.equalizers['header'].update();

    //   // Abort the XHR request
    //   xhr.abort();

    //   // Open the request
    //   xhr.open('POST', url + select.value, true);

    //   // Set the request headers
    //   xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    //   // Send the request
    //   xhr.send();
    // });
  });
})();